import {useCallback, useEffect} from 'react';

import {DmsDataGrid, queryParams} from '@dms/shared';

import {Nullish, suffixTestId, TestIdProps, useQueryState} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

import {JobSegments} from '../../../types/JobSegments';

interface FullyReturnedItemsDataGridProps extends TestIdProps {
  serviceCaseId: string;
  orderId: string | Nullish;
  jobId: string | Nullish;
  fullyReturnedItemsCount: number;
}

export function FullyReturnedItemsDataGrid(props: FullyReturnedItemsDataGridProps) {
  const [, setActiveSegment] = useQueryState(queryParams.SERVICE_CASE_JOB_SEGMENT);

  // Redirect to WORK_ITEMS if fullyReturnedItemsCount is 0
  useEffect(() => {
    if (props.fullyReturnedItemsCount === 0) {
      setActiveSegment(JobSegments.WORK_ITEMS);
    }
  }, [props.fullyReturnedItemsCount, setActiveSegment]);

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({
      ...filter,
      serviceOrderId: props.orderId ?? '',
      serviceCaseId: props.serviceCaseId,
      serviceJobId: props.jobId ?? '',
    }),
    [props.orderId, props.serviceCaseId, props.jobId]
  );

  // Don't render anything if count is 0 (user will be redirected)
  if (props.fullyReturnedItemsCount === 0) {
    return null;
  }

  return (
    <DmsDataGrid
      autoHeight
      queryModifier={queryModifier}
      gridCode="service-case-order-items-returned"
      data-testid={suffixTestId('fullyReturnedItems', props)}
    />
  );
}
